
class CapViewUserManagement {
  constructor(config) {
    this.config = config
  }
  
  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_user_management'
}

function create(config) {
  return new CapViewUserManagement(config)
}

export default {
  key,
  create,
}
